import React from "react";
import classes from "./styles/style.module.css";
import ProfileMenuItem from "./ProfileMenuItem";

const ProfileMenu = ({ title, items }) => {
  const menuIems = items.map((item, index) => {
    return (
      <ProfileMenuItem
        name={item.name}
        icon={item.icon}
        link={item.link}
        action={item.action}
        key={index}
      />
    );
  });
  return (
    <div className={classes.profileMenu}>
      <p>{title}</p>
      <div>{menuIems}</div>
    </div>
  );
};

export default ProfileMenu;
